// Phonemic Awareness Diagnostic (PA-D) — the module's ONLY import surface for
// code outside src/pa-diagnostic/ (App.js wiring uses exactly these exports).
// Tests may import module internals directly. See README.md for the contract.

export const PAD_TEST_TYPE = 'pa_diagnostic';
export const PAD_MODULE_LABEL = 'Phonemic Awareness Diagnostic';

// Route paths — declared here and ONLY here. App.js must reference these
// constants, never a '/pa-diagnostic' string literal (the isolation test
// enforces it), so the module's namespace stays in the module.
export const PAD_ROUTES = {
  assessment: '/pa-diagnostic/assessment',
  results: '/pa-diagnostic/results',
};

// Sidebar declaration (Step 0 decisions 2: 👂 / #be185d, collapsible, not
// teacher-toggleable, placed directly after the two existing PA groups).
export const PAD_SIDEBAR_GROUP = 'Phonemic Awareness Diagnostic';
export const PAD_SIDEBAR_ICON = '👂';
export const PAD_SIDEBAR_COLOR = '#be185d';

// Lazy page factory for App.js: `React.lazy(PadAssessmentLazy)`. A dynamic
// import keeps this surface data-light (no Firebase pulled into consumers
// that only need constants) and gives the page its own chunk.
export const PadAssessmentLazy = () => import('./pages/PadAssessment');
export const PadResultsLazy = () => import('./pages/PadResults');

export { loadTier, listTiers, PAD_TIER_IDS } from './lib/loadTier';
export { gradeToTier } from './lib/gradeToTier';

// Word-bank re-exports for tests (Step 1a): the stimulus/answer/exemplar
// collections, extracted by the same rules the design-session verifier used.
export {
  collectScoredStimuli,
  collectAnswerWords,
  collectExemplarWords,
  variantsOf,
} from './lib/collectBankWords';
